import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Recognise video-service URLs so we don't accidentally use them as <img src>.
// (Old data sometimes has a YouTube link stored in external_url instead of embed_url.)
const VIDEO_HOSTS = /(youtube\.com|youtu\.be|vimeo\.com|player\.vimeo\.com|dailymotion\.com|twitch\.tv)/i;

export const mediaUrl = (item) => {
  if (!item) return null;
  if (item.media_id) return `${API}/media/${item.media_id}`;
  if (item.thumb_id) return `${API}/media/${item.thumb_id}`;
  const ext = item.external_url;
  if (ext && !VIDEO_HOSTS.test(ext)) return ext;
  return null;
};

// If an item has a YouTube link stored anywhere (embed_url OR the legacy
// external_url field), return it — used to derive an embed thumbnail fallback.
export const embedSourceUrl = (item) => {
  if (!item) return null;
  if (item.embed_url) return item.embed_url;
  const ext = item.external_url;
  if (ext && VIDEO_HOSTS.test(ext)) return ext;
  return null;
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("imi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
